import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Select } from 'antd';

import { ChevronDown } from '../../assets/icons';
import './LegalSidebarMobile.scss';

const LegalSidebarMobile = memo(({ policiesList, isLoading, activeScreen, setActiveScreen }) => {
  return (
    <div className='legalsidemobile'>
      {!!policiesList?.length && (
        <Select
          showArrow={false}
          value={activeScreen}
          popupClassName='sidebar-dropdown'
          loading={isLoading}
          notFoundContent={'No Data Available'}
          options={
            policiesList?.map((policy) => ({
              value: policy,
              label: (
                <>
                  {policy} <ChevronDown color='#C04F0F' verticalAlign='-6px' />
                </>
              ),
            })) ?? []
          }
          onChange={(value) => {
            setActiveScreen(value);
          }}
        />
      )}
    </div>
  );
});

LegalSidebarMobile.propTypes = {
  policiesList: PropTypes.array,
  isLoading: PropTypes.bool,
  activeScreen: PropTypes.string,
  setActiveScreen: PropTypes.func,
};

LegalSidebarMobile.defaultProps = {
  policiesList: ['No Data Available'],
  isLoading: false,
  activeScreen: 'No Data Available',
  setActiveScreen: () => {},
};

export default LegalSidebarMobile;
